import React, { useState } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DashboardReportsApi } from "api/DashboardReportsApi";
import { ConfirmDialog } from "primereact/confirmdialog";
import { useDeleteSingleReport } from "api/api-hooks/reports-hooks";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { T } from "services/lang/LanguageService";

type GenerateReportHistoryType = {
  data: Array<{ file: string }>;
  genId: number;

  closeDialog(): void;
};

const GeneratedReportHistoryList = (props: GenerateReportHistoryType) => {
  const [removeDialog, setRemoveDialog] = useState(false);

  const { mutate: deleteReportGeneration } = useDeleteSingleReport({
    onSuccess: () => {
      easasAlert({ summary: T("alert.report-table.report-deleted"), severity: "success" });
    },
    onFailure: () => {
      easasAlert({ summary: T("alert.report-table.failed-to-delete-report"), severity: "error" });
    },
  });

  const downloadReportBody = (rowData: { file: string }) => {
    return (
      (
        <div className="flex align-items-center">
          <Button
            icon="pi pi-download"
            className="p-button-rounded p-button-text p-button-sm"
            onClick={() => {
              window.open(DashboardReportsApi.getDownloadUrl(props.genId, rowData.file));
            }}
          />
        </div>
      ) || null
    );
  };

  const deleteGenerationBody = (rowData: { file: string }) => {
    const accept = () => {
      deleteReportGeneration({ reportId: rowData.file, genId: props.genId });
      if (props.data.length <= 1) {
        props.closeDialog();
      }
    };

    return (
      <>
        <ConfirmDialog
          visible={removeDialog}
          onHide={() => setRemoveDialog(false)}
          message={T("confirm-dialog.report-table.do-you-want-to-remove-this-report")}
          header={T("confirm-dialog.report-table.delete-confirmation")}
          icon="pi pi-info-circle"
          acceptClassName="p-button-danger"
          accept={accept}
        />
        <div className="flex align-items-center">
          <Button
            icon="pi pi-trash"
            style={{ color: "red" }}
            id="history-button"
            className="p-button-rounded p-button-text p-button-sm"
            onClick={() => {
              setRemoveDialog(true);
            }}
          />
        </div>
      </>
    );
  };

  return (
    <DataTable
      value={props.data}
      size="small"
      paginator
      responsiveLayout="scroll"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
      currentPageReportTemplate={`${T("word.showing")} {first} - {last} / {totalRecords}`}
      rows={10}
    >
      <Column field="file" header={T("word.file")} />
      <Column body={downloadReportBody} style={{ width: "0" }} />
      <Column body={deleteGenerationBody} style={{ width: "0" }} />
    </DataTable>
  );
};

export default GeneratedReportHistoryList;
